/** Strings owned by `src/features/participation/` — WP-03's Deelname
 * (engagement funnel) page. */
export const participation = {
  page: {
    title: 'Participation',
    lead: 'The engagement funnel: from invited to structurally active, plus daily engagement rates.',
    noScope: 'Select a company to see its participation numbers.',
    noDepartments: 'No department here has statistics you may see.',
    disclaimer:
      'All figures are indicative well-being insights and are not intended as a medical diagnosis. Trends are only shown for a sufficient number of participants (privacy by design).',
  },
  filters: {
    department: {
      label: 'Department',
    },
    location: {
      label: 'Location',
      all: 'All locations',
    },
  },
  funnel: {
    title: 'Engagement funnel',
    pctOfPrevious: '{{pct}}% of previous step',
    steps: {
      invited: 'Invited',
      activated: 'Activated',
      active_7d: 'Active (7d)',
      active_30d: 'Active (30d)',
      structurally_active: 'Structurally active',
      needs_reactivation: 'Needs reactivation',
    },
  },
  rates: {
    title: 'Engagement rates',
    keys: {
      daily_sync_pct: 'Daily sync',
      ai_coach_use_pct: 'AI-coach use',
      challenge_participation_pct: 'Challenge participation',
      notification_open_pct: 'Notification opens',
      break_adoption_pct: 'Break adoption',
      focus_rhythm_pct: 'Focus rhythm',
    },
  },
  breakdown: {
    department: 'By department',
    location: 'By location',
    pilotGroup: 'By pilot group',
    empty: 'No data to break down yet.',
    pilotGroupEmpty: 'No pilots have this department in scope yet.',
    ratio: '{{activated}}/{{invited}} · {{pct}}%',
    shielded: {
      badge: 'Shielded',
      message:
        'Not enough participants ({{invited}}) for a privacy-safe view — at least {{min}} required.',
    },
    columns: {
      name: 'Name',
      invited: 'Invited',
      activated: 'Activated',
      active30d: 'Active (30d)',
    },
  },
  status: {
    noData: '—',
  },
} as const;
